import React from "react";
import { cn } from "@gettactic/helpers";
import { CheckCircleIcon, XCircleIcon } from "lucide-react";

export interface WizardReviewFeatureItemProps {
  label: string;
  enabled: boolean;
  className?: string;
}

export const WizardReviewFeatureItem: React.FC<WizardReviewFeatureItemProps> = ({
  label,
  enabled,
  className
}) => (
  <div className={cn("flex items-center gap-2 text-sm", className)}>
    {enabled ? (
      <CheckCircleIcon className="size-4 text-green-500" />
    ) : (
      <XCircleIcon className="size-4 text-neutral-300" />
    )}
    <span className={enabled ? "text-neutral-900" : "text-neutral-400"}>{label}</span>
  </div>
);
